import { Helmet } from 'react-helmet-async';

const SEO = () => {
  return (
    <Helmet>
      {/* Primary Meta */}
      <html lang="he" />
      <title>אפריאט אדריכלות | משרד אדריכלות ועיצוב פנים - AFRIAT ARCHITECTURE</title>
      <meta name="description" content="משרד אפריאט אדריכלות - ליווי אדריכלי ועיצובי מלא מקצה לקצה. תכנון בתים פרטיים, עיצוב פנים, הדמיות תלת מימד, היתרי בנייה וליווי ביצוע. מהרעיון ועד מסירת המפתח." />
      <meta name="keywords" content="אפריאט אדריכלות, חן אפריאט, אדריכלית, משרד אדריכלות, עיצוב פנים, תכנון בתים פרטיים, אדריכלות מגורים, עיצוב פנים יוקרתי, הדמיות תלת מימד, היתר בנייה, ליווי אדריכלי, תכנון אדריכלי, עיצוב בתים, שיפוץ דירות, תכנון מטבחים, עיצוב חללים, אדריכלות מודרנית, עיצוב וילות, תכנון פנים, Afriat Architecture" />
      <link rel="canonical" href="https://afriat-arc.co.il/" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="he_IL" />
      <meta property="og:site_name" content="אפריאט אדריכלות - AFRIAT ARCHITECTURE" />
      <meta property="og:title" content="אפריאט אדריכלות | משרד אדריכלות ועיצוב פנים" />
      <meta property="og:description" content="משרד אפריאט אדריכלות - ליווי אדריכלי ועיצובי מלא מקצה לקצה. תכנון בתים פרטיים, עיצוב פנים, הדמיות תלת מימד וליווי ביצוע." />
      <meta property="og:url" content="https://afriat-arc.co.il/" />
      <meta property="og:image" content="https://afriat-arc.co.il/og-image.png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="אפריאט אדריכלות - משרד אדריכלות ועיצוב פנים" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="אפריאט אדריכלות | משרד אדריכלות ועיצוב פנים" />
      <meta name="twitter:description" content="ליווי אדריכלי ועיצובי מלא מקצה לקצה. תכנון בתים פרטיים, הדמיות תלת מימד וליווי ביצוע." />
      <meta name="twitter:image" content="https://afriat-arc.co.il/og-image.png" />

      {/* AI Search Optimization */}
      <meta name="ai-content-description" content="Afriat Architecture is an Israeli boutique architecture and interior design firm. The firm provides end-to-end architectural planning and interior design services for private homes and commercial projects. Services include: architectural planning, 3D renderings, building permits, construction supervision, kitchen planning, aluminum specifications, and full project management from initial concept to key handover." />

      {/* Geo */}
      <meta name="geo.region" content="IL" />
      <meta name="geo.placename" content="Israel" />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="author" content="אפריאט אדריכלות" />
      <meta name="publisher" content="אפריאט אדריכלות - AFRIAT ARCHITECTURE" />
      <meta name="format-detection" content="telephone=yes" />

      {/* Structured Data - LocalBusiness */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ArchitectureFirm",
        "name": "אפריאט אדריכלות - AFRIAT ARCHITECTURE",
        "alternateName": ["Afriat Architecture", "חן אפריאט אדריכלות", "Afriat Arc"],
        "description": "משרד בוטיק לאדריכלות ועיצוב פנים - ליווי אדריכלי ועיצובי מלא מקצה לקצה, מהרעיון ועד מסירת המפתח",
        "url": "https://afriat-arc.co.il",
        "logo": "https://afriat-arc.co.il/og-image.png",
        "image": "https://afriat-arc.co.il/og-image.png",
        "telephone": "+972-54-814-5494",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "IL",
          "addressRegion": "Israel"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "32.0853",
          "longitude": "34.7818"
        },
        "priceRange": "$$$$",
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        "sameAs": [
          "https://www.instagram.com/hen_afriat_arc"
        ],
        "knowsAbout": [
          "אדריכלות",
          "עיצוב פנים",
          "תכנון בתים פרטיים",
          "הדמיות תלת מימד",
          "היתרי בנייה",
          "עיצוב פנים יוקרתי",
          "Architecture",
          "Interior Design",
          "3D Rendering",
          "Building Permits"
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "שירותי אדריכלות ועיצוב פנים",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "תכנון אדריכלי",
                "description": "תכנון אדריכלי מלא לבתים פרטיים ופרויקטים מסחריים"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "עיצוב פנים",
                "description": "עיצוב פנים מקצועי הכולל בחירת חומרים, ריהוט ותאורה"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "הדמיות תלת מימד",
                "description": "הדמיות תלת מימדיות ריאליסטיות לצפייה בפרויקט לפני הביצוע"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "היתרי בנייה",
                "description": "הכנת תיק מידע והגשה לוועדה לקבלת היתר בנייה"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "ליווי ביצוע",
                "description": "ליווי מקצועי בשלב הביצוע כולל תכניות עבודה מפורטות לכל בעלי המקצוע"
              }
            }
          ]
        }
      })}</script>

      {/* Breadcrumb */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "אפריאט אדריכלות",
          "item": "https://afriat-arc.co.il/"
        }]
      })}</script>

      {/* WebSite with SearchAction for AI */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "אפריאט אדריכלות - AFRIAT ARCHITECTURE",
        "url": "https://afriat-arc.co.il",
        "inLanguage": "he-IL",
        "description": "משרד בוטיק לאדריכלות ועיצוב פנים - ליווי אדריכלי ועיצובי מלא מקצה לקצה"
      })}</script>
    </Helmet>
  );
};

export default SEO;
